import { Directive, effect, inject, input, type OnDestroy, output, ViewContainerRef } from '@angular/core';
import { PlatformService } from '../services/platform.service';

@Directive({
    selector: '[bigSharedIsInViewport]',
})

/**
 * Emits if attachted element is in viewport
 * Usage: <div (bigSharedIsInViewport)="onIsInViewport($event)">I'm in viewport</div>
 */
export class IsInViewportDirective implements OnDestroy {
    private readonly platformService = inject(PlatformService);
    private readonly viewContainerRef = inject(ViewContainerRef);

    public readonly threshold = input(0);
    public readonly bigSharedIsInViewport = output<boolean>();

    private observer?: IntersectionObserver;

    public constructor() {
        effect(() => {
            if(this.platformService.isPlatformServer()) {
                return;
            }

            const observedElement = this.viewContainerRef.element.nativeElement.parentElement;

            if (!observedElement) {
                return;
            }

            this.observer = new IntersectionObserver(
                ([entry]) => {
                    this.intersectionObserverCallback(entry);
                },
                { threshold: this.threshold() },
            );

            this.observer.observe(observedElement);
        })
    }

    public ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = undefined;
        }
    }

    private intersectionObserverCallback(entry: IntersectionObserverEntry): void {
        this.bigSharedIsInViewport.emit(entry.isIntersecting);
    }
}
